import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  InputAdornment,
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import { loginIMSAdmin, signUp } from "../../app/store/actions/authActions";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button
} from "../../app/components/Styles";
import { isMobile } from "react-device-detect";
import { Image, Space, Table, Button } from "antd";
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
  idTableColumn,
} from "../../app/components/AntTableStyles";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { getVendors, relinkShopify, editVendors, resyncBosta, pullFincartStatuses, softDeleteVendors, syncUnfulfilledOrders } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline, Search } from "@mui/icons-material";
import EditBrandModal from "../../app/components/EditBrandModal";
import ActionDialog from "../../app/components/ActionDialog";

export const BrandsList = ({
  getVendors,
  relinkShopify,
  editVendors,
  syncUnfulfilledOrders,
  user,
  vendors,
  warehouseId,
  isLoading,
  resyncBosta,
  pullFincartStatuses,
  softDeleteVendors
}) => {
  const navigate = useNavigate();
  const [error, setError] = React.useState(null);
  const [terms, setTerms] = React.useState(false);
  const [selectedBrand, setSelectedBrand] = React.useState(null);
  const [openEditModal, setOpenEditModal] = React.useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const [brandToDelete, setBrandToDelete] = React.useState(null);
  const [brandToPullFincart, setBrandToPullFincart] = React.useState(null);
  const [openFincartPullDialog, setOpenFincartPullDialog] = React.useState(false);
  const [pullingFincartVendorId, setPullingFincartVendorId] = React.useState(null);
  const [search, setSearch] = React.useState('');
  const [appliedSearch, setAppliedSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const currentLocale = Cookies.get("i18next") || "en";
  const { t, i18n } = useTranslation();
  const PAGE_SIZE = 10;

  useEffect(() => {
    getVendors({
      page,
      limit: PAGE_SIZE,
      search: appliedSearch || undefined,
    });
  }, [page, appliedSearch]);

  const handleSearch = () => {
    setPage(1);
    setAppliedSearch(search.trim());
  };

  const handleEdit = (settings) => {
    Promise.resolve(editVendors({
      vendorId: selectedBrand._id,
      edits: settings
    })).then(() => {
      getVendors({
        page,
        limit: PAGE_SIZE,
        search: appliedSearch || undefined,
      });
    });
    setOpenEditModal(false);
  };

  const handleDeleteClick = (record) => {
    setBrandToDelete(record);
    setOpenDeleteDialog(true);
  };

  const handleDeleteConfirm = () => {
    if (brandToDelete) {
      softDeleteVendors({ vendorId: brandToDelete._id });
      setOpenDeleteDialog(false);
      setBrandToDelete(null);
    }
  };

  const handleDeleteCancel = () => {
    setOpenDeleteDialog(false);
    setBrandToDelete(null);
  };

  const handlePullFincartClick = (record) => {
    setBrandToPullFincart(record);
    setOpenFincartPullDialog(true);
  };

  const handlePullFincartCancel = () => {
    setOpenFincartPullDialog(false);
    setBrandToPullFincart(null);
  };

  const handlePullFincartConfirm = () => {
    if (!brandToPullFincart) {
      return;
    }
    const vendorId = brandToPullFincart._id;
    setOpenFincartPullDialog(false);
    setBrandToPullFincart(null);
    setPullingFincartVendorId(vendorId);
    Promise.resolve(pullFincartStatuses({ vendorId }))
      .finally(() => {
        setPullingFincartVendorId((current) => (current === vendorId ? null : current));
      });
  };

  const columns = [
    idTableColumn(),
    {
      title: 'Brand Name',
      dataIndex: 'brandName',
    },
    {
      title: 'Brand Email',
      dataIndex: 'email',
    },
    {
      title: 'Orders this month',
      dataIndex: 'monthOrders',
      defaultSortOrder: 'descend',
      sorter: (a, b) => (a.monthOrders ?? 0) - (b.monthOrders ?? 0),
    },
    {
      title: "Last month billable orders",
      dataIndex: 'lastMonthBillableOrders',
      sorter: (a, b) => (a.lastMonthBillableOrders ?? 0) - (b.lastMonthBillableOrders ?? 0),
      render: (val) => val ?? '—',
    },
    {
      title: 'Actions',
      render: (_, record) => <Space>
        <Button onClick={() => navigate(`/ims/admin/brand/${record._id}`)}>View Brand</Button>
        <Button onClick={() => relinkShopify({ vendorId: record._id })}>Relink Stock</Button>
        <Button onClick={() => syncUnfulfilledOrders({ vendorId: record._id })}>Pull Unfulfilled</Button>
        {record.shippingService === 'Bosta' && <Button onClick={() => resyncBosta({ vendorId: record._id })}>Resync Bosta</Button>}
        {record.shippingService === 'Fincart' && (
          <Button
            loading={pullingFincartVendorId === record._id}
            disabled={pullingFincartVendorId === record._id}
            onClick={() => handlePullFincartClick(record)}
          >
            Pull from Fincart
          </Button>
        )}
        <Button onClick={() => {
          setSelectedBrand(record);
          setOpenEditModal(true);
        }}>Edit Brand Details</Button>
        <Button danger onClick={() => handleDeleteClick(record)}>Soft Delete</Button>
      </Space>
    },
  ];

  const data = vendors?.docs?.map((row) => {
    return {
      _id: row._id,
      brandName: row.brandName,
      email: row.email,
      monthOrders: row.monthOrders,
      lastMonthBillableOrders: row.lastHistory?.billableOrders,
      allowToOpenPackage: row.allowToOpenPackage,
      fragileOrders: row.fragileOrders,
      receiveOrders: row.receiveOrders,
      usesEcom: row.usesEcom || false,
      shippingService: row.shippingService
    }
  })

  return (
    <div>
      <Box sx={{ width: "100%", px: 5 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Brands</Typography>
          <IconButton onClick={() => navigate("/ims/admin/brands/create")} sx={{ color: "var(--secColor)", mx: 2 }}><AddCircleOutline /></IconButton>
        </Box>
        <Box sx={{ mb: 2, maxWidth: 480 }}>
          <MainInput
            fullWidth
            placeholder="Search by brand name or email"
            value={search}
            onChange={({ target }) => setSearch(target.value)}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleSearch}
                    edge="end"
                    sx={{ color: "var(--secColor4)" }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <Box sx={antTableWrapperSx(isMobile, 1000)}>
          <Table
            columns={columns}
            dataSource={data}
            rowKey="_id"
            loading={isLoading}
            showSorterTooltip={{
              target: 'sorter-icon',
            }}
            pagination={defaultPaginatedTableProps({
              current: page,
              pageSize: PAGE_SIZE,
              total: vendors?.totalDocs,
              onChange: (nextPage) => setPage(nextPage),
              itemLabel: "brands",
            })}
            scroll={{ x: isMobile ? 300 : 1000 }}
          />
        </Box>
        <EditBrandModal
          open={openEditModal}
          handleClose={() => setOpenEditModal(false)}
          handleAccept={handleEdit}
          title="Edit Brand Details"
          brand={selectedBrand}
        />
        <ActionDialog
          open={openDeleteDialog}
          handleClose={handleDeleteCancel}
          handleAccept={handleDeleteConfirm}
          title="Confirm Deletion"
          content={`Are you sure you want to soft delete the brand "${brandToDelete?.brandName}"? This action cannot be undone.`}
        />
        <ActionDialog
          open={openFincartPullDialog}
          handleClose={handlePullFincartCancel}
          handleAccept={handlePullFincartConfirm}
          title="Pull from Fincart"
          content="This may take a few minutes. Pull latest Fincart statuses for this brand?"
        />
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  vendors: state?.records?.vendors
});

const mapDispatchToProps = { getVendors, relinkShopify, editVendors, resyncBosta, pullFincartStatuses, softDeleteVendors, syncUnfulfilledOrders };

export default connect(mapStateToProps, mapDispatchToProps)(BrandsList);
